import type { Coordinates } from 'maplibre-gl';
import type { StylePart } from '@/features/map';

export const CONE_SOURCE = 'cone';
export const PATH_SOURCE = 'path';

export interface ConeImage {
  url: string;
  coordinates: Coordinates;
}

const BLANK_PNG =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

/** Placeholder while there is no result (image sources cannot be empty). */
export const BLANK_CONE_IMAGE: ConeImage = {
  url: BLANK_PNG,
  coordinates: [
    [0, 0.001],
    [0.001, 0.001],
    [0.001, 0],
    [0, 0],
  ],
};

export const EMPTY_FEATURES: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: [] };

/** Result raster and hovered flight path, drawn above the basemap. */
export const glideStyle = (): StylePart => ({
  sources: {
    [CONE_SOURCE]: { type: 'image', ...BLANK_CONE_IMAGE },
    [PATH_SOURCE]: { type: 'geojson', data: EMPTY_FEATURES },
  },
  layers: [
    {
      id: 'cone',
      type: 'raster',
      source: CONE_SOURCE,
      paint: { 'raster-opacity': 0.75, 'raster-resampling': 'nearest', 'raster-fade-duration': 0 },
    },
    {
      id: 'path',
      type: 'line',
      source: PATH_SOURCE,
      paint: { 'line-color': '#000', 'line-width': 2, 'line-dasharray': [2, 2] },
    },
    {
      id: 'path-end',
      type: 'circle',
      source: PATH_SOURCE,
      filter: ['==', '$type', 'Point'],
      paint: {
        'circle-radius': 6,
        'circle-color': '#222',
        'circle-stroke-color': '#fff',
        'circle-stroke-width': 1.5,
      },
    },
  ],
});
